module.exports = __webpack_public_path__ + "e5c9e0d3ae0a084e72fd913b0e63cbe4.svg";